import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';

/**
 * Generated class for the AciklamaeklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-aciklamaekle',
  templateUrl: 'aciklamaekle.html',
})
export class AciklamaeklePage {
  aciklama:any={ID:-1,Name:""};
  isdurum:any={};

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("isVw") != null) {
        this.isdurum = navParams.get("isVw");
        var data = new FormData();
        data.append("Aciklama_id", this.isdurum.ID);
        this.bllOrtak.islem(data, "AciklamaGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.aciklama = Sonuc.SonucObject;
      
        }
        )
      }
  }

  ionViewDidLoad() {

  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.aciklama.Name == null || this.aciklama.Name == "") {
      mesaj = mesaj + "Lütfen Açıklama adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Aciklama_json", JSON.stringify(this.aciklama));
     
      this.bllOrtak.islem(formData, "AciklamaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}


// WEBPACK FOOTER //
// ./src/pages/Yonetim/aciklamaekle/aciklamaekle.ts